/**
 * Adds the custom animated desktop and touch behavior to Dawn's native
 * mega-menu details elements.
 */
document.addEventListener('DOMContentLoaded', () => {
  const detailsMenus = Array.from(document.querySelectorAll('details.mega-menu'));
  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  function closeAllExcept(excludeDetails) {
    detailsMenus.forEach((details) => {
      if (details === excludeDetails || !details.hasAttribute('open')) return;

      details.removeAttribute('open');
      const content = details.querySelector('.mega-menu__content');
      if (content) {
        content.style.visibility = 'hidden';
        content.style.pointerEvents = 'none';
        content.style.opacity = 0;
        content.style.maxHeight = '0px';
      }
    });
  }

  detailsMenus.forEach((details) => {
    const content = details.querySelector('.mega-menu__content');
    if (!content) return;

    function getXTranslate() {
      const isCentered =
        window.getComputedStyle(content).left === '50%' || content.id === 'MegaMenu-Content-3';
      return isCentered ? '-50%' : '0';
    }

    function openAnimation() {
      const xTranslate = getXTranslate();
      content.style.transition = 'none';
      content.style.maxHeight = '0px';
      content.style.opacity = 0;
      content.style.visibility = 'visible';
      content.style.pointerEvents = 'none';
      void content.offsetHeight;
      content.style.transition =
        'opacity 240ms ease-in-out, transform 240ms ease-in-out, max-height 300ms ease-in-out';
      content.style.maxHeight = content.scrollHeight + 40 + 'px';
      content.style.opacity = 1;
      content.style.transform = `translateX(${xTranslate}) translateY(0)`;
      content.style.pointerEvents = 'auto';
    }

    function closeAnimation() {
      const xTranslate = getXTranslate();
      content.style.transition =
        'opacity 180ms ease-in-out, max-height 220ms ease-in-out, transform 180ms ease-in-out';
      content.style.opacity = 0;
      content.style.maxHeight = '0px';
      content.style.transform = `translateX(${xTranslate}) translateY(-10px)`;
      content.style.pointerEvents = 'none';
      window.setTimeout(() => {
        if (!details.hasAttribute('open')) content.style.visibility = 'hidden';
      }, 260);
    }

    if (!isTouch) {
      details.addEventListener('toggle', () => {
        if (details.open) openAnimation();
        else closeAnimation();
      });
      details.addEventListener('mouseenter', () => {
        if (!details.open) details.open = true;
      });
      details.addEventListener('mouseleave', () => {
        if (details.open) details.open = false;
      });
      return;
    }

    const summary = details.querySelector('summary');
    if (!summary) return;

    summary.addEventListener(
      'pointerdown',
      (event) => {
        event.stopPropagation();
        event.preventDefault();
      },
      { capture: true, passive: false }
    );

    let toggleLocked = false;
    function lockToggle() {
      toggleLocked = true;
      window.setTimeout(() => {
        toggleLocked = false;
      }, 350);
    }

    summary.addEventListener(
      'click',
      (event) => {
        event.stopPropagation();
        event.preventDefault();
        if (toggleLocked) return;

        lockToggle();
        const alreadyOpen = details.hasAttribute('open');
        closeAllExcept(details);
        if (alreadyOpen) {
          details.removeAttribute('open');
          closeAnimation();
        } else {
          details.setAttribute('open', '');
          openAnimation();
        }
      },
      { passive: false }
    );

    document.addEventListener('click', (event) => {
      if (details !== document.querySelector('details.mega-menu[open]') || details.contains(event.target)) return;
      details.removeAttribute('open');
      closeAnimation();
    });
  });
});
